import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layers, LogOut, FolderOpen, ShoppingBag, Home, BookOpen, ClipboardList } from 'lucide-react';
import AdminCollections from './AdminCollections';
import AdminProducts from './AdminProducts';
import AdminSettings from './AdminSettings';
import AdminBlogs from './AdminBlogs';
import AdminOrders from './AdminOrders';
import { apiUrl, adminFetch, getAdminToken, clearAdminAuth } from '../../api';
import './Admin.css';

function AdminDashboard() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('orders');

  const admin = (() => {
    try { return JSON.parse(localStorage.getItem('admin')); } catch { return null; }
  })();

  useEffect(() => {
    if (!admin || !getAdminToken()) {
      clearAdminAuth();
      navigate('/admin/login');
      return;
    }
    // Verify the token is still valid; bounce to login if it has expired.
    adminFetch(apiUrl('/api/admin/me')).then((res) => {
      if (!res.ok) { clearAdminAuth(); navigate('/admin/login'); }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    clearAdminAuth();
    navigate('/admin/login');
  };

  return (
    <div className="admin-page">
      <header className="admin-topbar">
        <div className="admin-brand"><Layers size={20} /> <span>Elaichi Admin</span></div>

        <nav className="admin-tabs">
          <button
            className={`admin-tab ${tab === 'orders' ? 'active' : ''}`}
            onClick={() => setTab('orders')}
          >
            <ClipboardList size={16} /> Orders
          </button>
          <button
            className={`admin-tab ${tab === 'collections' ? 'active' : ''}`}
            onClick={() => setTab('collections')}
          >
            <FolderOpen size={16} /> Collections &amp; Listings
          </button>
          <button
            className={`admin-tab ${tab === 'products' ? 'active' : ''}`}
            onClick={() => setTab('products')}
          >
            <ShoppingBag size={16} /> Products
          </button>
          <button
            className={`admin-tab ${tab === 'blogs' ? 'active' : ''}`}
            onClick={() => setTab('blogs')}
          >
            <BookOpen size={16} /> Blog
          </button>
          <button
            className={`admin-tab ${tab === 'homepage' ? 'active' : ''}`}
            onClick={() => setTab('homepage')}
          >
            <Home size={16} /> Homepage
          </button>
        </nav>

        <div className="admin-topbar-right">
          <span className="admin-muted">{admin?.email}</span>
          <button className="admin-btn-ghost" onClick={logout}><LogOut size={15} /> Logout</button>
        </div>
      </header>

      {tab === 'orders' && <AdminOrders />}
      {tab === 'collections' && <AdminCollections />}
      {tab === 'products' && <AdminProducts />}
      {tab === 'blogs' && <AdminBlogs />}
      {tab === 'homepage' && (
        <div className="admin-shell">
          <main className="admin-main"><AdminSettings /></main>
        </div>
      )}
    </div>
  );
}

export default AdminDashboard;
